import React from 'react';
import {
  Button, Card, Modal, ModalProps,
} from 'react-bootstrap';
import LightBox from 'components/shared/form/lightbox';
// @ts-ignore
import NoPhoto from 'assets/images/NoPhoto.png';
// @ts-ignore
import styles from './tools.module.scss';

interface HsmvPhotoResultModalProps extends ModalProps {

}

export function HsmvPhotoResultModal(props: HsmvPhotoResultModalProps) {
  // eslint-disable-next-line no-console
  // Check if data is available and modify the "photo" property in jsonResponse
  if (props.data && props.data.jsonResponse && props.data.jsonResponse.photo) {
    props.data.jsonResponse.photo = ''; // Set "photo" property to an empty string
  }
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size={props.size}
      aria-labelledby={props.label}
      centered={props.centered}
      backdrop={props.static}
      animation={props.animation}
      className={props.className}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 2 }}>
            <p>{props.subTitle}</p>
            <textarea
              className={styles.hsmvPhotoResultBody}
              value={JSON.stringify(props.data.jsonResponse, null, 2)}
              placeholder="Result"
              readOnly
            />
          </div>
          {props.data && (
          <div style={{ flex: 1 }}>
            <Card className={`${styles.profilePhoto} shadow-sm`}>
              {props.data.photo ? (
                <LightBox title="">
                  <Card.Img
                    variant="top"
                    alt="Drivers License Photo"
                    src={`data:image/png;base64,${props.data.photo.fileContents}`}
                    className="border-bottom"
                  />
                </LightBox>
              ) : (
                <Card.Img
                  variant="top"
                  alt="Care giver Profile Photo Does Not Exist"
                  src={NoPhoto}
                  className="border-bottom"
                />
              )}
            </Card>
          </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="k-button text-center"
          variant="primary"
          onClick={props.onHide}
        >
          {props.buttontext}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
